import { React, useMemo } from "react";
import PropTypes from "prop-types";
import { useAuth, useMissionRoleApplicantViewsCount } from "hooks";

/**
 * withApplicantViewsCount
 *
 * @param {Element} WrappedComponent
 */
export default function withApplicantViewsCount(WrappedComponent) {
  const ApplicantViewsCountWrapper = ({ data: applicantsData, ...props }) => {
    const { isAdmin } = useAuth();

    const { data: viewsCountData } = useMissionRoleApplicantViewsCount({
      ids: applicantsData?.map((a) => a.id).filter(Boolean) ?? [],
      skip: !isAdmin,
    });

    const mergedData = useMemo(() => {
      if (!applicantsData || !viewsCountData) return applicantsData;

      const countsById = viewsCountData.missionRoleApplicantViewsCount.reduce((acc, curr) => {
        acc[curr.id] = curr;
        return acc;
      }, {});

      return applicantsData.map((applicant) => ({
        ...applicant,
        viewsCount: countsById[applicant.id] || null,
      }));
    }, [applicantsData, viewsCountData]);

    return <WrappedComponent {...props} data={mergedData} />;
  };

  ApplicantViewsCountWrapper.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
  };

  return ApplicantViewsCountWrapper;
}
